// Single source of truth for the gameName values stored in game history
// records, so the recording call sites and the Game History page's tabs
// can't drift out of sync with each other.
export const GAME_HISTORY_NAMES = {
  COUNTING: "counting_game",
  TEAMS: "2v2_teams",
  CUTTHROAT: "cutthroat",
};
